"use strict";

import * as React from "react";
import PropTypes from "prop-types";
import { isNumberKeyFromEvent, getIntegerFromEvent } from "../../utilities/EventsHelper";
import LockIcon from "../../controls/LockIcon";

export default class LockoutSettings extends React.Component {
    constructor(props) {
        super(props);

        this._handleAccountLockoutThresholdChange = this._handleAccountLockoutThresholdChange.bind(this);
        this._handleAccountLockoutThresholdKeyPress = this._handleAccountLockoutThresholdKeyPress.bind(this);
        this._handleAccountLockoutIntervalChange = this._handleAccountLockoutIntervalChange.bind(this);
        this._handleAccountLockoutIntervalKeyPress = this._handleAccountLockoutIntervalKeyPress.bind(this);
    }

    render() {
        if (!this.props.accountLockoutPolicy || this.props.accountLockoutPolicy == null)
            return null;

        return (
            <div id="LockoutSettings">
                <h5>Lock-Out Settings</h5>
                <div className="control-row">
                    <div className="oneLineString">Allow</div>
                    <input className="picker-hollow textbox oneLineString"
                        id="threshold"
                        maxLength="3"
                        onChange={this._handleAccountLockoutThresholdChange}
                        onKeyPress={this._handleAccountLockoutThresholdKeyPress}
                        tabIndex="0"
                        type="text"
                        value={this.props.accountLockoutPolicy.threshold}
                        disabled={this.props.settingsLocks.threshold}
                    />
                    <LockIcon isLocked={this.props.settingsLocks.threshold} />
                    <div className="oneLineString">consecutive bad password attempts before locking the account for </div>
                    <input className="picker-hollow textbox oneLineString"
                        id="interval"
                        maxLength="3"
                        onChange={this._handleAccountLockoutIntervalChange}
                        onKeyPress={this._handleAccountLockoutIntervalKeyPress}
                        tabIndex="0"
                        type="text"
                        value={this.props.accountLockoutPolicy.interval}
                        disabled={this.props.settingsLocks.interval}
                    />
                    <LockIcon isLocked={this.props.settingsLocks.interval} />
                    <div className="oneLineString">minutes</div>
                </div>
            </div>
        );
    }

    _handleAccountLockoutThresholdChange (e) {
        const threshold = getIntegerFromEvent(e);
        this.props.setAccountLockoutThreshold(threshold);
    }

    _handleAccountLockoutThresholdKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }

    _handleAccountLockoutIntervalChange (e) {
        const interval = getIntegerFromEvent(e);
        this.props.setAccountLockoutInterval(interval);
    }

    _handleAccountLockoutIntervalKeyPress (e) {
        if (!isNumberKeyFromEvent(e)) {
            e.preventDefault();
        }
    }
}

LockoutSettings.propTypes = {
    accountLockoutPolicy: PropTypes.shape({
        threshold: PropTypes.number.isRequired,
        interval: PropTypes.number.isRequired
    }),
    settingsLocks: PropTypes.shape({
        threshold: PropTypes.bool.isRequired,
        interval: PropTypes.bool.isRequired
    }),
    setAccountLockoutInterval: PropTypes.func,
    setAccountLockoutThreshold: PropTypes.func
};

